import React from 'react';
import { StorePhoneNumberView } from "./StorePhoneNumberView";
import { translate } from '../../Services/translation';
import { storeIdConverter } from '../../Services/StoreId.service';

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const minimize = (str) => {
    return str.toLowerCase().replace('mandag', 'Man').replace('tirsdag', 'Tir').replace('onsdag', 'Ons').replace('torsdag', 'Tors').replace('fredag', 'Fre').replace('lørdag', 'Lør').replace('søndag', 'Søn');
}

export const StoreItemView = ({ urlToStore, storeId, storeName, storeAddress, displayedOpeningHours, storePhone, storePostalCode, storeCity, storeRegion }) => 
(<div className="store__item" data-storeid={storeId} data-storename={storeName}>
    <div className="store__item-title">
        <a href={urlToStore} className="store-link">
            <span>{storeName}</span>
        </a>
    </div>

    <div className="row">
        <div className="columns small-12 medium-6">
            <div className="store__item-address">
                <span>{storeAddress},</span><br />
                <span>{storePostalCode} {storeCity}</span>
            </div>
        </div>
        <div className="columns small-12 medium-6">
            <div className="store__item-openHours">
                {displayedOpeningHours && displayedOpeningHours.length && displayedOpeningHours.map((item, index) => item ? <div className="item" key={'storeItemView openHours' + index}>
                    <span className="label">{item != null && item.text != null ? minimize(capitalize(item.text)) : null}:</span>
                    <span className="value">{item != null && item.time != null ? item.time : null}</span>
                </div> : null)}
            </div>
        </div>
    </div>

    <div className="row">
        <div className="columns small-12 medium-7">
            {StorePhoneNumberView(storePhone)}
        </div>
        <div className="columns small-12 medium-5">
            {storeId ? <a href={`${window.__litium.baseBookingUrl}?current_optician=${storeIdConverter(storeId).asNumber}`} className="store__smallitem-orderlink">{translate('homepage_bookingappointment.buttontext')}</a> : null}
        </div>
    </div>
</div>);